<template>
  <v-layout>
    <v-flex xs4>
      <AppScrollContainer :height="height">
        <CampaignBudgetPeriodTable
          v-model="currentCampaignBudget"
          :items="campaignBudgets"
        />
      </AppScrollContainer>
    </v-flex>
    <v-divider vertical />
    <v-flex xs4>
      <AppScrollContainer :height="height">
        <CampaignBudgetPeriodTableRow
          ref="campaignBudgetPeriodTableRow"
          v-model="currentCampaignBudgetCreativeSchedule"
          :creativeSchedules="currentCampaignBudgetCreativeSchedules"
          :campaignBudget="currentCampaignBudget"
          :readOnly="true"
        >
          <template v-slot:empty v-if="!currentCampaignBudget">
            キャンペーン予算期間を選択してください
          </template>
        </CampaignBudgetPeriodTableRow>
      </AppScrollContainer>
    </v-flex>
    <v-divider vertical />
    <v-flex xs4>
      <AppScrollContainer :height="height">
        <CreativeTable
          v-model="currentCreative"
          :items="creatives"
          :readOnly="true"
        >
          <template v-slot:empty>
            <span v-if="!currentCampaignBudget">
              キャンペーン予算期間を選択してください
            </span>
            <span v-else-if="!currentCampaignBudgetCreativeSchedule">
              配信スケジュールを選択してください
            </span>
          </template>
        </CreativeTable>
      </AppScrollContainer>
    </v-flex>
  </v-layout>
</template>

<script>
import CampaignBudgetPeriodTable from './CampaignModalPageCreativeModeCampaignWithSchedulesCampaignBudgetPeriodTable'
import CampaignBudgetPeriodTableRow from './CampaignModalPageCreativeModeCampaignWithSchedulesCampaignBudgetPeriodTableRow'
import CreativeTable from './CampaignModalPageCreativeModeCampaignWithSchedulesCreativeTable'
import { CreativeRepository } from '@/models/Creative'
export default {
  name: 'CampaignModalPageConfirmCreativeTable',
  components: {
    CampaignBudgetPeriodTable,
    CampaignBudgetPeriodTableRow,
    CreativeTable,
  },
  props: {
    campaignBudgets: {
      type: Array,
      default: () => [],
    },
    activeOnly: Boolean,
  },
  data() {
    return {
      height: 200,
      creativesPool: [],
      currentCampaignBudget: null,
      currentCampaignBudgetCreativeSchedule: null,
      currentCreative: null,
      loading: false,
    }
  },
  computed: {
    currentCampaignBudgetCreativeSchedules() {
      return this.currentCampaignBudget === null
        ? []
        : this.currentCampaignBudget.creativeSchedules
    },
    creatives() {
      if (this.creativesPool.length === 0) return []
      const creativeList = this.currentCampaignBudgetCreativeSchedule.creatives
        .map(({ id }) => {
          return this.findCreative(id)
        })
        .flat()
      return this.activeOnly
        ? creativeList.filter(c => c.isActive)
        : creativeList
    },
  },
  watch: {
    currentCampaignBudget() {
      this.currentCampaignBudgetCreativeSchedule = this.currentCampaignBudget.creativeSchedules[0]
      this.currentCreative = null
    },
    currentCampaignBudgetCreativeSchedule() {
      this.fetchCreatives()
    },
  },
  created() {
    this.currentCampaignBudget = this.campaignBudgets[0]
    this.currentCampaignBudgetCreativeSchedule = this.currentCampaignBudget.creativeSchedules[0]
  },
  methods: {
    async fetchCreatives() {
      try {
        this.loading = true
        this.creativesPool = []
        // creativeScheduleが存在しない場合、APIを叩かない
        if (this.currentCampaignBudgetCreativeSchedule === undefined) return
        this.creativesPool = await CreativeRepository.findByIdsWithFolderInfo(
          this.currentCampaignBudgetCreativeSchedule.creatives.flat(),
        )
      } catch (e) {
        console.error(e)
        throw new Error('クリエイティブデータが取得できません。')
      } finally {
        this.loading = false
      }
    },
    findCreative(id) {
      return this.creativesPool.find(c => c.id === id)
    },
  },
}
</script>

<style scoped lang="scss">
.headerRow {
  height: 24px;

  th {
    padding: 0 8px !important;
    text-align: left;
  }
}

.itemRow {
  td {
    padding: 0 8px !important;
  }
}
</style>
